<template>
  <div
    :class="`base-control-wrapper-container ${
      focused ? 'input-focused' : 'input-unfocused'
    }`"
  >
    <slot :label="labelTitle" name="header">
      <v-card-text v-if="labelTitle" class="base-control-container-header">
        {{ labelTitle }}
      </v-card-text>
    </slot>
    <ValidationProvider
      ref="validationProvider"
      v-slot="{ errors }"
      :name="field"
      :rules="applyRules"
    >
      <slot :onFocus="onFocus" name="form-control" />
      <slot :errors="errors" name="errors">
        <v-card-text
          v-if="field && errors && errors.length"
          class="base-control-container-error"
        >
          {{ errors[0] }}
        </v-card-text>
      </slot>
    </ValidationProvider>
    <slot name="footer" />
    <slot name="help">
      <div v-if="helpTitle && helpContent && focused" class="base-help-root">
        <BaseHelp
          v-bind="$props"
          :description="helpContent"
          :title="helpTitle"
        />
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import BaseFormControl from "../../helpers/BaseFormControl";
import BaseHelp from "../widgets/BaseHelp.vue";

@Component({
  name: "BaseControlWrapper",
  components: {
    ValidationProvider,
    BaseHelp,
  },
})
export default class BaseControlWrapper extends BaseFormControl {
  created(): void {
    super.created();
  }

  onFocus(flag: boolean) {
    this.focused = flag;
  }
}
</script>

<style lang="scss">
.base-control-wrapper-container {
  position: relative;

  .base-help-root {
    position: absolute;
    top: 30px;
    right: -280px;
  }

  &.input-focused {
    .v-input__slot {
      background-color: $white !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
    }
  }

  &.input-unfocused {
    .v-input__slot {
      background-color: $element_background_color !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0px 1000px $element_background_color inset !important;
    }
  }

  .base-control-container-checkbox {
    padding: 0;
    margin: 0;

    .v-input__slot {
      background-color: inherit !important;

      .v-label {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: $secondary_text_color;
      }
    }
  }
}

@media screen and (max-width: 1190px) {
  .base-help-root {
    position: relative !important;
    margin-top: 10px;
    top: 0 !important;
    right: 0 !important;

    .base-help-text {
      width: 100% !important;
    }

    .base-help-text:after {
      border-right: none !important;
      border-left: none !important;
    }
  }
}
</style>
